import React from 'react';
import { IconProps } from '.';

const SvgCircleYouTube = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill='#FF4C4C' d='M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Z' />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M18.255 7.762c.217.222.373.497.452.8C19 9.675 19 12 19 12s0 2.324-.293 3.439a1.79 1.79 0 0 1-.452.799 1.754 1.754 0 0 1-.785.464C16.375 17 12 17 12 17s-4.375 0-5.47-.298a1.755 1.755 0 0 1-.785-.464 1.79 1.79 0 0 1-.452-.8C5 14.325 5 12 5 12s0-2.324.293-3.439a1.79 1.79 0 0 1 .452-.799c.217-.222.488-.381.785-.464C7.625 7 12 7 12 7s4.375 0 5.47.298c.297.083.568.242.785.464ZM14.555 12 10.24 9.511v4.978L14.555 12Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCircleYouTube;
